
export const LogoutPath = "/logout";
export const ItemsPath = "/items";
export const ItemPath = "/items/:id";
export const RootPath = "/";
export const ItemById = (id: string) => `/items/${id}`;
